/* Giancarlo Paoli — presentatore collezione.
   Lo scorrimento è nativo (scroll-snap + momentum di sistema): qui dentro
   non c'è nessun motore di scorrimento e nessun requestAnimationFrame.
   Il conteggio si aggiorna con un osservatore sulle scene, non con un
   listener che legge scrollLeft a ogni pixel. */

(function () {
  'use strict';

  function avvia(sezione) {
    if (sezione.__gpPresPronto) return;
    sezione.__gpPresPronto = true;

    var pista = sezione.querySelector('[data-gp-pres-pista]');
    if (!pista) return;
    // I pannelli sono tutti navigabili, ma le scene sono solo le fotografie:
    // la schermata di chiusura non è la diciannovesima scena.
    var pannelli = Array.prototype.slice.call(pista.children);
    var scene = Array.prototype.slice.call(pista.querySelectorAll('.gp-pres__scena'));
    var quadri = sezione.querySelectorAll('[data-gp-pres-quadro]');
    var conta = sezione.querySelector('[data-gp-pres-conta]');
    var annuncio = sezione.querySelector('[data-gp-pres-annuncio]');
    var prec = sezione.querySelector('[data-gp-pres-prec]');
    var succ = sezione.querySelector('[data-gp-pres-succ]');
    var bottoneShow = sezione.querySelector('[data-gp-pres-showroom]');
    var barra = sezione.querySelector('[data-gp-pres-carico]');
    var attiva = 0;

    /* ------------------------------------------------ velo sulle scene */

    var animato = document.documentElement.classList.contains('gp-motion');
    if (animato && 'IntersectionObserver' in window) {
      var ioVelo = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (!v.isIntersecting) return;
          ioVelo.unobserve(v.target);
          v.target.setAttribute('data-gp-in', '');
        });
      }, { root: pista, threshold: 0.35 });
      for (var q = 0; q < quadri.length; q++) ioVelo.observe(quadri[q]);
    } else {
      for (var q2 = 0; q2 < quadri.length; q2++) quadri[q2].setAttribute('data-gp-in', '');
    }

    /* --------------------------------------------- quale scena è davanti */

    function aggiorna(i) {
      if (i === attiva) return;
      attiva = i;
      var suScena = i < scene.length;
      if (conta) {
        conta.hidden = !suScena;
        var b = conta.querySelector('b');
        if (b && suScena) b.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      }
      if (annuncio) {
        annuncio.textContent = suScena
          ? 'Scena ' + (i + 1) + ' di ' + scene.length
          : 'Fine della collezione';
      }
      if (prec) prec.disabled = i === 0;
      if (succ) succ.disabled = i === pannelli.length - 1;
    }

    // Quale pannello è davanti si ricava dalla posizione di scorrimento.
    // Un osservatore sarebbe più elegante, ma qui il dato è già esatto e
    // non dipende da callback che il browser può rimandare.
    var ultimoCalcolo = 0;
    function calcola() {
      var ora = Date.now();
      if (ora - ultimoCalcolo < 100) return;
      ultimoCalcolo = ora;
      var largh = pista.clientWidth || 1;
      aggiorna(Math.max(0, Math.min(pannelli.length - 1, Math.round(pista.scrollLeft / largh))));
    }
    pista.addEventListener('scroll', calcola, { passive: true });

    /* ----------------------------------------------------- navigazione */

    function vai(i) {
      i = Math.max(0, Math.min(pannelli.length - 1, i));
      var lento = matchMedia('(prefers-reduced-motion: reduce)').matches;
      pista.scrollTo({ left: pannelli[i].offsetLeft, behavior: lento ? 'auto' : 'smooth' });
      // Se lo scorrimento morbido non parte (scheda in secondo piano, motore
      // sospeso), lo stato si allinea comunque.
      setTimeout(calcola, 60);
      setTimeout(calcola, 700);
    }
    if (prec) prec.addEventListener('click', function () { vai(attiva - 1); });
    if (succ) succ.addEventListener('click', function () { vai(attiva + 1); });

    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); vai(attiva + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); vai(attiva - 1); }
      else if (e.key === 'Home') { e.preventDefault(); vai(0); }
      else if (e.key === 'End') { e.preventDefault(); vai(pannelli.length - 1); }
    });

    /* ------------------------------------------------- modo showroom */

    // Allo stand la rete è quello che è. Il precaricamento si lancia a mano,
    // la sera prima sul wifi, e non promette niente sul funzionamento
    // offline: quello resta il PDF sull'iPad.
    var precaricato = false;
    function precarica() {
      if (precaricato) return Promise.resolve();
      precaricato = true;
      var img = sezione.querySelectorAll('.gp-pres__scatto img');
      var totale = img.length;
      var fatte = 0;
      if (barra) { barra.hidden = false; barra.style.width = '0%'; }
      function passo() {
        fatte++;
        if (barra) barra.style.width = Math.round(fatte / totale * 100) + '%';
        if (fatte >= totale && barra) {
          setTimeout(function () { barra.hidden = true; barra.style.width = '0%'; }, 500);
        }
      }
      var catena = Promise.resolve();
      Array.prototype.forEach.call(img, function (el) {
        catena = catena.then(function () {
          return new Promise(function (risolvi) {
            el.loading = 'eager';
            var sorgente = el.currentSrc || el.src;
            if (!sorgente || el.complete) { passo(); risolvi(); return; }
            var pre = new Image();
            if (el.srcset) pre.srcset = el.srcset;
            if (el.sizes) pre.sizes = el.sizes;
            pre.onload = pre.onerror = function () { passo(); risolvi(); };
            pre.src = sorgente;
          });
        });
      });
      return catena;
    }

    if (bottoneShow) {
      bottoneShow.addEventListener('click', function () {
        precarica();
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (sezione.requestFullscreen) {
          sezione.requestFullscreen().catch(function () { /* negato: resta a finestra */ });
        } else if (sezione.webkitRequestFullscreen) {
          sezione.webkitRequestFullscreen();
        }
      });
    }

    // iPhone non concede lo schermo pieno a un elemento che non sia un video:
    // in quel caso il bottone precarica lo stesso, che è il valore vero.
    document.addEventListener('fullscreenchange', function () {
      var dentro = document.fullscreenElement === sezione;
      sezione.setAttribute('aria-live', dentro ? 'off' : 'polite');
      if (bottoneShow) bottoneShow.setAttribute('aria-pressed', dentro ? 'true' : 'false');
    });

    attiva = -1;
    aggiorna(0);
  }

  function collega() {
    var nodi = document.querySelectorAll('[data-gp-pres]');
    for (var i = 0; i < nodi.length; i++) avvia(nodi[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collega);
  else collega();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('[data-gp-pres]') : null;
    if (s) avvia(s);
  });
})();
